module.exports = __webpack_public_path__ + "img/Group 1437254716 (2).b9bad427.png";